<div
  class="ws-tooltip"
  [ngClass]="panelClass"
  [class.ws-tooltip--above]="placement === 'above'"
  [class.ws-tooltip--below]="placement === 'below'"
  (mouseenter)="onPanelMouseEnter()"
  (mouseleave)="onPanelMouseLeave()"
  *ngIf="parsed as content"
>
  <ng-container [ngSwitch]="content.type">
    <div *ngSwitchCase="'text'" class="tt-text-row" [class.tt-text-row--admin]="adminCopyable">
      <button
        *ngIf="adminCopyable && (isSuperadmin$ | async) && copyValue"
        type="button"
        class="tt-copy-btn"
        [attr.aria-label]="copyLabel"
        [attr.title]="copyLabel"
        (click)="copyToClipboard($event)"
      >
        <span class="material-icons tt-copy-icon">content_copy</span>
      </button>
      <div class="tt-text">{{ content.text }}</div>
    </div>

    <ng-container *ngSwitchCase="'template'">
      <ng-container
        *ngTemplateOutlet="content.template; context: content.templateContext"
      ></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'list'">
      <div class="tt-row" *ngFor="let row of content.rows">
        <span class="tt-label">{{ row.label }}</span>
        <span class="tt-value">{{ row.value }}</span>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'detailed'">
      <div class="tt-title">
        <img
          *ngIf="content.titleIconUrl"
          class="tt-title-icon"
          [src]="content.titleIconUrl"
          alt=""
        />
        <ng-container
          *ngIf="content.titleIconTemplate"
          [ngTemplateOutlet]="content.titleIconTemplate"
        ></ng-container>
        <span>{{ content.titleText }}</span>
      </div>
      <div class="tt-row" *ngFor="let row of content.rows">
        <span class="tt-label">{{ row.label }}</span>
        <span class="tt-value">{{ row.value }}</span>
      </div>
    </ng-container>
  </ng-container>

  <div class="tt-arrow" [style.left.px]="arrowLeft"></div>
</div>
